import { useTranslation } from 'react-i18next'

import { FormFieldsContainer, FormFieldSelectNG } from '../../Form'
import { FormikField } from '../../Formik'
import { InputField } from '../../Input'
import { useEpostFormContext } from '../Epost.hooks'

import {
  EPOST_FORM_FIELDS_NAME_C4_ENVELOPE,
  EPOST_FORM_FIELDS_NAME_COLOR,
  EPOST_FORM_FIELDS_NAME_LETTERS,
  EPOST_FORM_FIELDS_NAME_PAGES_COUNT,
  EPOST_FORM_FIELDS_NAME_PRINT_SIDE,
  EPOST_FORM_FIELDS_NAME_PROVIDER,
  EPOST_FORM_FIELDS_NAME_REGISTERED_LETTER,
} from './EpostFormFields.constants'
import {
  getEpostFormFieldsC4EnvelopeOptions,
  getEpostFormFieldsColorSchemeOptions,
  getEpostFormFieldsPrintSideOptions,
  getEpostFormFieldsRegisteredLetterOptions,
} from './EpostFormFields.utils'
import { EpostFormFieldsEnvelopeSelect } from './EpostFormFieldsEnvelopeSelect'
import { EpostFormFieldsRadioField } from './EpostFormFieldsRadioField'
import { EpostFormFieldsRegisteredLetterSelect } from './EpostFormFieldsRegisteredLetterSelect'

import * as styles from './EpostFormFields.module.css'

function EpostFormFields() {
  const { t } = useTranslation()

  const { isCalculating, isInitiating, readonly } = useEpostFormContext()

  const colorSchemeOptions = getEpostFormFieldsColorSchemeOptions()

  const printSideOptions = getEpostFormFieldsPrintSideOptions()

  const c4EnvelopeOptions = getEpostFormFieldsC4EnvelopeOptions(t)

  const registeredLetterOptions = getEpostFormFieldsRegisteredLetterOptions(t)

  const isLoading = !readonly && isInitiating
  const disabled = readonly || isCalculating

  return (
    <FormFieldsContainer className={styles.fieldsContainer}>
      <FormikField
        borderless
        readonly
        Component={InputField}
        fieldComponentProps={{
          isLoading,
          label: `${t('Epost.ProviderFieldLabelKey')}:`,
          required: true,
        }}
        name={EPOST_FORM_FIELDS_NAME_PROVIDER}
      />
      <FormikField
        borderless
        readonly
        Component={InputField}
        fieldComponentProps={{
          isLoading,
          label: `${t('Epost.LettersFieldLabelKey')}:`,
        }}
        name={EPOST_FORM_FIELDS_NAME_LETTERS}
      />

      <FormikField
        borderless
        readonly
        Component={InputField}
        fieldComponentProps={{
          isLoading,
          label: `${t('Epost.PagesCountFieldLabelKey')}:`,
        }}
        name={EPOST_FORM_FIELDS_NAME_PAGES_COUNT}
      />

      <FormikField
        Component={FormFieldSelectNG}
        Select={EpostFormFieldsRegisteredLetterSelect}
        disabled={disabled}
        fieldComponentProps={{
          fieldInputClassName: styles.registeredLetterFieldInput,
          isLoading,
          label: `${t('Epost.RegisteredLetterFieldLabelKey')}:`,
        }}
        name={EPOST_FORM_FIELDS_NAME_REGISTERED_LETTER}
        options={registeredLetterOptions}
      />

      <EpostFormFieldsRadioField
        disabled={disabled}
        fieldComponentProps={{
          isLoading,
          label: `${t('Epost.ColorSchemeFieldLabelKey')}:`,
        }}
        name={EPOST_FORM_FIELDS_NAME_COLOR}
        options={colorSchemeOptions}
      />
      <EpostFormFieldsRadioField
        disabled={disabled}
        fieldComponentProps={{
          isLoading,
          label: `${t('Epost.PrintSideFieldLabelKey')}:`,
        }}
        name={EPOST_FORM_FIELDS_NAME_PRINT_SIDE}
        options={printSideOptions}
      />
      <FormikField
        Component={FormFieldSelectNG}
        Select={EpostFormFieldsEnvelopeSelect}
        disabled={disabled}
        fieldComponentProps={{
          isLoading,
          label: `${t('Epost.EnvelopeFieldLabelKey')}:`,
          required: true,
        }}
        name={EPOST_FORM_FIELDS_NAME_C4_ENVELOPE}
        options={c4EnvelopeOptions}
      />
    </FormFieldsContainer>
  )
}

export default EpostFormFields
